// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__KVqda","image":"card_image__u32Yp","title":"card_title__8wqoE","description":"card_description__P3AW7"};